"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _style = _interopRequireDefault(require("./style.css"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down5"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } /* eslint-disable jsx-a11y/mouse-events-have-key-events */
var Dropdown = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var title = _ref.title,
    children = _ref.children,
    onClick = _ref.onClick,
    openOnHover = _ref.openOnHover,
    Icon = _ref.Icon,
    trigger = _ref.trigger,
    isActive = _ref.isActive,
    position = _ref.position;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setOpen = _useState2[1];
  var dropdownRef = (0, _react.useRef)();
  var handleClick = (0, _react.useCallback)(function (e) {
    if (!dropdownRef.current.contains(e.target)) {
      setOpen(false);
      document.removeEventListener('mousedown', handleClick);
    }
  }, []);
  (0, _react.useEffect)(function () {
    return function () {
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);
  var handleButtonOnClick = function handleButtonOnClick(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    onClick(e);
    setOpen(!isOpen);
    if (isOpen) {
      document.removeEventListener('mousedown', handleClick);
    } else {
      document.addEventListener('mousedown', handleClick);
    }
  };
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      dropdownRef: dropdownRef,
      toggle: handleButtonOnClick,
      isOpen: isOpen
    };
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].dropdown,
    ref: dropdownRef
  }, trigger ? /*#__PURE__*/_react["default"].createElement("span", {
    onClick: !openOnHover ? handleButtonOnClick : undefined,
    onMouseOver: openOnHover ? handleButtonOnClick : undefined
  }, trigger) : /*#__PURE__*/_react["default"].createElement("a", {
    className: (0, _classnames["default"])(_style["default"].link, isActive && _style["default"].active),
    style: {
      paddingRight: '0.3em'
    },
    onClick: !openOnHover ? handleButtonOnClick : undefined,
    onMouseOver: openOnHover ? handleButtonOnClick : undefined
  }, title ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, Icon && /*#__PURE__*/_react["default"].createElement(Icon, null), /*#__PURE__*/_react["default"].createElement("span", null, title), /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement(Icon, null), /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null))), isOpen && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_style["default"].menu, _style["default"][position])
  }, children));
});
Dropdown.displayName = 'Dropdown';
Dropdown.propTypes = {
  title: _propTypes["default"].any,
  children: _propTypes["default"].node,
  onClick: _propTypes["default"].func,
  openOnHover: _propTypes["default"].bool,
  isSecondary: _propTypes["default"].bool,
  icon: _propTypes["default"].func,
  trigger: _propTypes["default"].node,
  isActive: _propTypes["default"].bool,
  position: _propTypes["default"].string
};
Dropdown.defaultProps = {
  children: null,
  title: null,
  onClick: function onClick() {
    return null;
  },
  openOnHover: false,
  position: 'left'
};
var _default = exports["default"] = Dropdown;